import React from 'react'
import {
  Box,
  Text
} from 'grommet'

export default function SuccessBanner({
  message
}) {
  return (
    <Box
      align='center'
      background='success'
      margin={{ vertical: 'small' }}
      pad='xsmall'
      round='xsmall'
      width='100%'
    >
      <Text
        color='white'
        size='small'
      >
        {message}
      </Text>
    </Box>
  )
}